import React, { useState } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

export const ProductImageBase = ({
  backImageAlt,
  frontImageAlt,
  backImageOnHover,
  frontImageOnHover,
  imgOnHover,
  img,
}) => {
  // Some image ids don't exist on the image server (404) - don't show them broken
  const [failed, setFailed] = useState({});
  const onError = (src) => () => setFailed((f) => ({ ...f, [src]: true }));
  const loads = (src) => !!src && !failed[src];

  const fallback = loads(imgOnHover) ? imgOnHover : null;
  const front = loads(img) ? img : fallback;
  const back = loads(imgOnHover) ? imgOnHover : front;

  if (!front) {
    return <div className={cn(styles.imgContainer, styles.missingImage)} />;
  }

  return (
    <div className={styles.imgContainer}>
      <img
        alt={backImageAlt}
        className={cn(styles.backImage, backImageOnHover)}
        src={back}
        onError={onError(back)}
      />
      <img
        alt={frontImageAlt}
        className={cn(styles.frontImage, frontImageOnHover)}
        src={front}
        onError={onError(front)}
      />
    </div>
  );
};
